import {Network} from 'stellar-sdk';

const NETWORK = {
  available: {
    master: {
      horizonURL: 'https://api.master.ssn.digital',
      networkPassphrase: "ssn_master_network"
    },
    testing: {
      horizonURL: 'https://api.testing.ssn.digital',
      networkPassphrase: "ssn_testing_network"
    },
    production: {
      horizonURL: 'https://api.ssn.digital',
      networkPassphrase: "ssn_production_network"
    }
  },
  defaultName: 'master',
};

export default NETWORK;



// WEBPACK FOOTER //
// ./src/constants/network.js